import trimValue from './trimValue';
var trimPayload = function trimPayload(payload) {
  var keys = Object.keys(payload);
  var result = keys.reduce(function (acc, key) {
    acc[key] = trimValue(payload[key]);
    return acc;
  }, {});
  return result;
};
export default trimPayload;